import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=0b504d92&scoped=true"
import script from "./stepper.vue?vue&type=script&lang=js"
export * from "./stepper.vue?vue&type=script&lang=js"
import style0 from "./stepper.vue?vue&type=style&index=0&id=0b504d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b504d92",
  null
  
)

export default component.exports